module.exports = __webpack_public_path__ + "img/controler_visiteur_read.03602dda.png";